// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"94d93c40","138":"1016a528","314":"d517a8a2","787":"6a9758b6","973":"5ca3cba3"}[chunkId] + ".chunk.js";
};